<template>
  <main class="flex w-full">
    <section class="md:px-14 mt-8 flex flex-col justify-start w-full">
      <form
        @submit.prevent="submit()"
        @change="disabled = false"
        class="grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md"
      >
        <div class="col-span-12">
          <div class="flex justify-between items-center">
            <h6>
              {{
                $t("labels.generic", {
                  pt: "Títulos e premiações",
                  en: "Titles and awards",
                })
              }}
            </h6>
            <Button
              type="submit"
              label="Salvar"
              class="btn-primary p-button-sm"
              :loading="loading"
              :disabled="disabled || validation()"
            />
          </div>
        </div>

        <div class="col-span-10">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Título",
                en: "Title",
              })
            }}
          </p>
          <InputText id="title" type="text" v-model="user.title" />
        </div>

        <div class="col-span-4">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Site pessoal",
                en: "Personal site",
              })
            }}
          </p>
          <InputText id="generalUrl" type="text" v-model="user.generalUrl" />
        </div>

        <div class="col-span-4">
          <p class="mb-2">Lattes</p>
          <InputText id="lattesUrl" type="text" v-model="user.lattesUrl" />
        </div>

        <div class="col-span-4">
          <p class="mb-2">Linkedin</p>
          <InputText id="linkedinUrl" type="text" v-model="user.linkedinUrl" />
        </div>

        <div class="col-span-12">
          <p class="mb-2">
            {{
              $t("labels.generic", {
                pt: "Biografia ",
                en: "Biography",
              })
            }}
          </p>
          <Editor
            id="description"
            v-model="user.description"
            editorStyle="height: 320px"
            @textChange="disabled = false"
          />

          <small
            :class="`${
              user.description?.length > 5000 ? 'text-h-error-400' : 'invisible'
            }`"
          >
            {{
              $t("labels.generic", {
                pt: "Tamanho foi exedido",
                en: "Size has been exceeded",
              })
            }}
          </small>
        </div>
      </form>
    </section>
  </main>
</template>

<script lang="ts">
import { TeacherProfile } from "@/models/user.model";
import { UsersRest } from "@/services/rest/users.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "teacherProfile",
  components: {},
  props: {
    user: {
      required: true,
      type: Object as PropType<TeacherProfile>,
      default: new TeacherProfile(),
    },
  },
  computed: {
    rest(): UsersRest {
      return new UsersRest();
    },
    userFromStorage(): any {
      return getUserFromStorage();
    },
  },
  data() {
    return {
      loading: false as boolean,
      disabled: true as boolean,
    };
  },
  methods: {
    submit(): void {
      this.loading = true;
      const data = new TeacherProfile();
      data.id = this.user.id ?? undefined;
      data.title = this.user.title;
      data.generalUrl = this.isUrl(this.user.generalUrl);
      data.lattesUrl = this.isUrl(this.user.lattesUrl);
      data.linkedinUrl = this.isUrl(this.user.linkedinUrl);
      data.description = this.user.description;
      this.rest.updateTeacherProfile(this.userFromStorage.id, data).subscribe({
        next: () => {
          this.loading = false;
          this.$toast.add(ToastFactory.success(Messages.USER_UPDATED));
        },
        error: () => {
          this.loading = false;
        },
      });
    },
    isUrl(value: string): string {
      if (value?.startsWith("http://") || value?.startsWith("https://")) {
        value = value ?? "";
      } else {
        value = "https://" + value?.replace("https://" || "http://", "") ?? "";
      }
      return value;
    },
    validation(): boolean {
      return (
        this.user.title == "" ||
        this.user.generalUrl == "" ||
        this.user.lattesUrl == "" ||
        this.user.linkedinUrl == "" ||
        this.user.generalUrl == "https://" ||
        this.user.generalUrl == "http://" ||
        this.user.lattesUrl == "https://" ||
        this.user.lattesUrl == "http://" ||
        this.user.linkedinUrl == "https://" ||
        this.user.linkedinUrl == "http://" ||
        this.user.description == "" ||
        this.user.description?.length > 5000
      );
    },
  },
});
</script>
